/**
 * CLE-2820 — the procedures sent with an eligibility check, for the AI second opinion's context only.
 *
 * Read from the same form state the order saves into `serviceDetails.procedures`. Shaped to always
 * pass the API's validation (code 1–10 characters, description at most 200, at most 50 entries), so
 * sending them can never make an eligibility check fail: anything that would not fit is dropped or
 * trimmed rather than sent. Nothing selected means nothing is sent.
 */

export interface IEligibilityProcedure {
  code: string;
  description?: string;
}

export const ELIGIBILITY_PROCEDURES_MAX = 50;
const CODE_MAX_LENGTH = 10;
const DESCRIPTION_MAX_LENGTH = 200;

export const buildEligibilityProcedures = (
  serviceDetails: unknown
): IEligibilityProcedure[] => {
  if (!Array.isArray(serviceDetails)) return [];
  const seen = new Set<string>();
  const procedures: IEligibilityProcedure[] = [];
  serviceDetails.forEach((procedure: any) => {
    const code = String(procedure?.code ?? procedure?.cptCode ?? "").trim();
    if (!code || code.length > CODE_MAX_LENGTH || seen.has(code)) return;
    if (procedures.length >= ELIGIBILITY_PROCEDURES_MAX) return;
    seen.add(code);
    const rawDescription = procedure?.cptDescription ?? procedure?.description;
    const description =
      typeof rawDescription === "string"
        ? rawDescription.trim().slice(0, DESCRIPTION_MAX_LENGTH)
        : "";
    procedures.push(description ? { code, description } : { code });
  });
  return procedures;
};
